import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { notifApi } from '../../api/notifications.js';

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  function refresh() {
    notifApi.list({ limit: 100 }).then((d) => { setItems(d?.items || []); setUnread(d?.unread || 0); });
  }
  useEffect(refresh, []);

  async function markAll() { await notifApi.markAllRead(); refresh(); }
  async function markOne(id) { await notifApi.markRead(id); refresh(); }

  return (
    <section>
      <header className="page-header">
        <h1>Notifications</h1>
        <div className="actions">
          <span className="muted">{unread} unread</span>
          {unread > 0 && <button className="btn ghost" onClick={markAll}>Mark all read</button>}
        </div>
      </header>

      <div className="card">
        {items.length === 0 && <div className="muted center">No notifications yet.</div>}
        <ul className="notif-list">
          {items.map((n) => (
            <li key={n.id} className={n.read_at ? 'read' : 'unread'}>
              <div className="notif-icon">{iconFor(n.type)}</div>
              <div className="notif-main">
                <div className="notif-row">
                  <strong>{n.title}</strong>
                  <span className="muted small">{new Date(n.created_at).toLocaleString()}</span>
                </div>
                {n.body && <div className="muted small">{n.body}</div>}
                <div className="actions">
                  {n.resource_url && <Link to={n.resource_url} className="btn ghost small">Open</Link>}
                  {!n.read_at && <button className="btn ghost small" onClick={() => markOne(n.id)}>Mark read</button>}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

function iconFor(type) {
  if (type?.startsWith('workflow.escalated')) return '⚠';
  if (type?.startsWith('workflow.approved')) return '✓';
  if (type?.startsWith('workflow.rejected')) return '✗';
  return '•';
}
